import { NgModule } from '@angular/core';
import { BrowserModule } from '@angular/platform-browser';
import { SimpleIconsFozzyComponent } from './simple-icons-fozzy.component';
 @NgModule({
    imports:      [ BrowserModule ],
    providers:    [],
    declarations: [ SimpleIconsFozzyComponent ],
    exports:      [ SimpleIconsFozzyComponent ],
    bootstrap:    []
})
export class SimpleIconsFozzyModule {}
